import { render } from "./ThanksForRating.vue?vue&type=template&id=a42987ae&scoped=true"
import script from "./ThanksForRating.vue?vue&type=script&lang=js"
export * from "./ThanksForRating.vue?vue&type=script&lang=js"

import "./ThanksForRating.vue?vue&type=style&index=0&id=a42987ae&scoped=true&lang=css"

import exportComponent from "E:\\coding\\pharaoh_frog_barber\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a42987ae"]])

export default __exports__